'use client';

import { Button } from '~/components/primitives';
import { useI18n } from '~/features/i18n';
import { useCatalog_EditMode_Session } from './session';

/** Cog button in the booking page header. Toggles `?edit`. Hidden below `lg`.
 *
 * The click routes through `session.enter()` / `session.exit()` so that dirty
 * rules trigger the Save / Discard / Cancel modal instead of a silent exit. */
export const Catalog_EditMode_ToggleButton: React.FC = () => {
    const i18n = useI18n();
    const session = useCatalog_EditMode_Session();
    const isEditing = session.step !== null;

    return (
        <Button
            variant="outline"
            size="sm"
            iconBefore={isEditing ? 'cross' : 'settings'}
            onClick={isEditing ? session.exit : session.enter}
            className="max-lg:hidden"
            data-testid="bizz-booking-edit-toggle"
        >
            {isEditing
                ? i18n._('bizz.booking.edit.button.exit', undefined, {
                      message: 'Stop editing catalog',
                  })
                : i18n._('bizz.booking.edit.button.enter', undefined, {
                      message: 'Edit catalog',
                  })}
        </Button>
    );
};
